import * as Yup from 'yup';

export type TransferFormType = {
  transactionAt: Date | null;
  tempTransactionAt: Date | null;
  needApproval: boolean;
  amount: number;
  description: string;
  fromAccountType: string | null;
  fromAccountable: string | null;
  toAccountType: string | null;
  toAccountable: string | null;
  number?: string;
  status?: string;
  refId?: string;
};

export const transferSchema = () =>
  Yup.object()
    .shape({
      transactionAt: Yup.date().nullable().required(),
      amount: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .min(0)
        .required(),
      description: Yup.string().nullable(),
      needApproval: Yup.boolean(),
      fromAccountType: Yup.string().nullable().required(),
      fromAccountable: Yup.string().nullable().required(),
      toAccountType: Yup.string().nullable().required(),
      toAccountable: Yup.string().nullable().required(),
      refId: Yup.string(),
    })
    .required();
